import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Stack, Typography } from "@mui/material";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    RelatedLink,
} from "components/detail";

export const PostShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const record = data?.data;

    // 내용이 JSON 문자열인지 판별
    const isJson = (str: any) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    게시글 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    게시글을 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="제목" value={record?.title} />
                        {record && isJson(record?.content) ? (
                            <FieldItem
                                label="내용"
                                span={2}
                                multiline
                                value={JSON.stringify(
                                    JSON.parse(record?.content ?? ""),
                                    null,
                                    2,
                                )}
                            />
                        ) : (
                            <FieldItem
                                label="내용"
                                span={2}
                                multiline
                                value={record?.content}
                            />
                        )}
                        <FieldItem label="수정일" value={record?.postUpdateDate} />
                        <FieldItem
                            label="첨부이미지"
                            value={
                                <RelatedLink
                                    to={`/images?filters[0][field]=targetId&filters[0][operator]=eq&filters[0][value]=${record?.id}&filters[1][field]=category&filters[1][operator]=eq&filters[1][value]=POST`}
                                    label="바로가기"
                                />
                            }
                        />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
